import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { UserSummaryProductModel, UserSummaryModel, UserSummaryProdInfoModel, UserManageModel } from './../../../../models/';
import {
  APPLICATION_JSON, USER_REMOVE_CTO_REQUEST_ID, USER_REMOVE_CTO_TRACKID,
  USER_SUMMARY_CTO_REQUEST_ID, USER_SUMMARY_CTO_TRACKID
} from '../../user-summary.config';
import { ANALYTICS_CONSTANTS } from 'config';

declare var ENV_PORTAL;
const ENV_PORTAL_DOMAIN = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';

@Injectable()
export class UserSummaryDataService {

  inputData: UserSummaryProdInfoModel;

  constructor(private http: HttpClient, private utilityService: UtilityService,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  getInfoMock(getDetailsservice) {
    return this.httpClientService.get(getDetailsservice).pipe(
       map((res: HttpResponse<any>) => res.body));
  }
  getInfo(getDetailsservice, requestObject) {
    return this.httpClientService.authorizedPut(getDetailsservice, requestObject)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  formatData(inputArr, userInfo) {
    let index = 0;
    this.inputData = new UserSummaryProdInfoModel();
    this.inputData.userInfo = userInfo;
    this.inputData.userSummaryProductModelArr = [];
    for (let item of inputArr.dataJson) {
      // this.inputData.userInfo.firstName = item.assignedToEmployeeFirstName;
      // this.inputData.userInfo.lastName = item.assignedToEmployeeLastName;
      // this.inputData.userInfo.email = item.assignedToEmployeeEmail;
      // // this.inputData.userInfo.contactNumber = item.assignedToEmployeePhoneNumber;
      // this.inputData.userInfo.contactNumber = '';
      // this.inputData.userInfo.displayName = item.assignedToDisplayName;
      // this.inputData.userInfo.id = item.assignedToEmployeeClientId;

      this.inputData.userSummaryProductModelArr[index] = new UserSummaryProductModel();
      this.inputData.userSummaryProductModelArr[index].billingCtn = this.utilityService.onBlurFormat(item.bucketClientId, 'dot');
      this.inputData.userSummaryProductModelArr[index].fan = item.accountClientId;
      // this.inputData.userSummaryProductModelArr[index].productDescription = item.serviceDescription;
      this.inputData.userSummaryProductModelArr[index].productName = item.serviceOfferName;
      this.inputData.userSummaryProductModelArr[index].productDescription = item.serviceName;
      this.inputData.userSummaryProductModelArr[index].serviceOfferCode = item.serviceOfferCode;
      this.inputData.userSummaryProductModelArr[index].id = item.id;
      this.inputData.userSummaryProductModelArr[index].clientId = item.clientId;
      this.inputData.userSummaryProductModelArr[index].licenseClientId = item.clientLicenseId;
      this.inputData.userSummaryProductModelArr[index].extProperties = item.extProperties;
      this.inputData.userSummaryProductModelArr[index].fanType = item.fanType;
      if (item.fanType === ENV_PORTAL_DOMAIN) {
        this.inputData.userSummaryProductModelArr[index].fanTypeFlag = false;
      } else if (item.fanType === undefined) {
        this.inputData.userSummaryProductModelArr[index].fanTypeFlag = false;
      } else {
        this.inputData.userSummaryProductModelArr[index].fanTypeFlag = true;
      }
      index = index + 1;
    }
    return this.inputData;
  }

  formateUserData(item) {
    this.inputData = new UserSummaryProdInfoModel();
    this.inputData.userInfo = new UserSummaryModel();
    this.inputData.userSummaryProductModelArr = [];
    this.inputData.userInfo.firstName = item.firstName;
    this.inputData.userInfo.lastName = item.lastName;
    this.inputData.userInfo.email = item.email;
    this.inputData.userInfo.contactNumber = this.utilityService.formatTelephoneNumber(item.phoneNumber);
    this.inputData.userInfo.displayName = item.displayName;
    this.inputData.userInfo.id = item.clientId;
    return this.inputData;
  }

  removeUser(getDetailsservice) {
    return this.httpClientService.authorizedDelete(getDetailsservice)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  setUserManageToSession(id, obj) {
    let set_obj = new UserManageModel();
    set_obj = obj;
    sessionStorage.setItem('user-manage-' + id, JSON.stringify(set_obj));
  }

  getUserManageFromSession(id) {
    const usr_info = sessionStorage.getItem('user-manage-' + id);
    return JSON.parse(usr_info);
  }

  unAssignUser(url, companyId, reqObj) {
    const headers = new HttpHeaders();
    const unAssignUrl = url + companyId + '/licenses/bulk';
    return this.httpClientService.authorizedPut(unAssignUrl, reqObj, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  getUserDetails(url) {
    const headers = new HttpHeaders();
    return this.httpClientService.authorizedGet(url, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  // Page Load
  createPageLoadProperties(url: string, title: string) {
    const dataLayer = {};
    const removeProductId = url.substring(0, url.lastIndexOf('/'));
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + removeProductId;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_USER_SUMMARY;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =  ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    if (ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError = (error) => {
    return throwError(error);
  }
}
